<template>
	<div id="app" :class="isMobile == 'mobile' ? 'phoneStyle' : ''" >
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		data(){
			return {
				isMobile:false
			}
		},
		created(){
			let _this = this
			let deviceType = _this.getDeviceType()
			console.log('deviceType')
			console.log(deviceType)
			window.sessionStorage.setItem('deviceType',deviceType)
		},
		methods:{
			getDeviceType(){
				const userAgent = navigator.userAgent;
				const screenWidth = window.innerWidth;
				const mobileKeywords = [
					'Android', 'webOS', 'iPhone', 'iPad', 'iPod',
					'BlackBerry', 'Windows Phone', 'Mobile', 'Tablet'
				];
				const isMobileDevice = mobileKeywords.some(keyword => 
					userAgent.includes(keyword)
				);
				if (isMobileDevice || screenWidth <= 768) {
					return 'mobile';
				} else {
					return 'desktop';
				}
			}
		}
	}
</script>
<style scoped>
	.phoneStyle{
		font-size: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue